import React, { useState } from 'react';
import { AppRequesterController } from '../../../../services/appRequester/appRequesterController';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ModalRegisterInstagramPage from '.';

const AppRequesterConst = new AppRequesterController()
const ModalRegisterInstagramPageController = ({ show, handleClose, cnpj, getInstagramById }) => {
    const [validated] = useState(false);
    const [bot, setBot] = useState(false)
    const [showfeedbackName, setShowfeedbackName] = useState(false);
    const [showfeedbackId, setShowfeedbackId] = useState(false);
    const [showfeedbackToken, setShowfeedbackToken] = useState(false);
    const [showfeedbackPostback, setShowfeedbackPostback] = useState(false);
    const [showfeedbackBotUrl, setShowfeedbackBotUrl] = useState(false);
    const [showfeedbackApiUrl, setShowfeedbackApiUrl] = useState(false);
    const [showfeedbackIdNlp, setShowfeedbackIdNlp] = useState(false);
    const [showfeedbackIdUser, setShowfeedbackIdUser] = useState(false);

    const [pageName, setPageName] = useState('');
    const [pageId, setPageId] = useState('');
    const [pageToken, setPageToken] = useState('');
    const [pageTokenPostback, setPagePostback] = useState('');
    const [pageBotUrl, setPageBotUrl] = useState('');
    const [pageApiUrl, setPageApiUrl] = useState('');
    const [pageIdNlp, setPageIdNlp] = useState('');
    const [pageIdUser, setPageIdUser] = useState('');


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const cancelButton = () => {
        clearFields();
        handleClose();
    }

    const clearFields = () => {
        setShowfeedbackName(false);
        setShowfeedbackId(false);
        setShowfeedbackIdUser(false);
        setShowfeedbackToken(false);
        setShowfeedbackPostback(false);
        setShowfeedbackBotUrl(false);
        setShowfeedbackApiUrl(false);
        setShowfeedbackIdNlp(false);
        setPageName('');
        setPageId('');
        setPageToken('');
        setPagePostback('');
        setPageBotUrl('');
        setPageApiUrl('');
        setBot(false);
        setPageIdNlp('');
    }

    return <ModalRegisterInstagramPage
        show={show}
        handleClose={handleClose}
        cnpj={cnpj}
        clearFields={clearFields}
        validated={validated}
        showfeedbackName={showfeedbackName}
        showfeedbackId={showfeedbackId}
        showfeedbackToken={showfeedbackToken}
        showfeedbackPostback={showfeedbackPostback}
        showfeedbackBotUrl={showfeedbackBotUrl}
        showfeedbackApiUrl={showfeedbackApiUrl}
        showfeedbackIdNlp={showfeedbackIdNlp}
        bot={bot}
        setBot={setBot}
        setShowfeedbackName={setShowfeedbackName}
        setShowfeedbackId={setShowfeedbackId}
        setShowfeedbackToken={setShowfeedbackToken}
        setShowfeedbackIdNlp={setShowfeedbackIdNlp}
        setShowfeedbackPostback={setShowfeedbackPostback}
        setShowfeedbackBotUrl={setShowfeedbackBotUrl}
        setShowfeedbackApiUrl={setShowfeedbackApiUrl}
        pageName={pageName}
        pageId={pageId}
        pageToken={pageToken}
        pagePostback={pageTokenPostback}
        pageBotUrl={pageBotUrl}
        pageApiUrl={pageApiUrl}
        pageIdNlp={pageIdNlp}
        setPageName={setPageName}
        setPageId={setPageId}
        setPageToken={setPageToken}
        setPagePostback={setPagePostback}
        setPageBotUrl={setPageBotUrl}
        setPageApiUrl={setPageApiUrl}
        setPageIdNlp={setPageIdNlp}
        AppRequesterConst={AppRequesterConst}
        dispatch={dispatch}
        navigate={navigate}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        cancelButton={cancelButton}
        getInstagramById={getInstagramById}
        showfeedbackIdUser={showfeedbackIdUser}
        setShowfeedbackIdUser={setShowfeedbackIdUser}
        pageIdUser={pageIdUser}
        setPageIdUser={setPageIdUser}
    />
};

export default ModalRegisterInstagramPageController;